<template>
  <v-row>
    <v-col cols="12">
      <v-card class="card-container" elevation="0">
        <v-data-table
          :headers="headers"
          :items="pagedItems"
          :item-key="'_id'"
          :items-per-page="itemsPerPage"
          :page.sync="page"
          :height="tableHeight"
          fixed-header
          hide-default-footer
          :style="tableVars"
        >
          <template v-slot:[`item.image`]="{ item }">
            <v-img
              :src="getImage(item.image)"
              max-width="80"
              max-height="60"
              contain
              class="rounded my-2"
            ></v-img>
          </template>

          <template v-slot:[`item.title`]="{ item }">
            {{ item.title || "-" }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              small
              :color="getStatusColor(item.status)"
              text-color="white"
            >
              {{ item.status || "-" }}
            </v-chip>
          </template>

          <template v-slot:[`item.author`]="{ item }">
            {{ item.author || "-" }}
          </template>
          
           <template v-slot:[`item.tags`]="{ item }">
            <div v-if="item.tags">
              <v-chip
                v-for="(tag, i) in item.tags"
                :key="i"
                small
                label
                color="#F3F4F6"
                text-color="#374151"
                class="mr-1 my-1"
                style="border-radius: 6px; font-weight: 500;"
              >
                {{ tag }}
              </v-chip>
            </div>
            <span v-else>-</span>
          </template>

          <template v-slot:[`item.createdAt`]="{ item }">
            {{ formatDate(item.createdAt) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-center">
              <v-btn
                text
                class="d-flex align-center action-btn"
                @click="$emit('edit', item)"
              >
                <div class="detail-btn mr-2">
                  <v-icon size="20" color="#F4811F">mdi-pencil-outline</v-icon>
                </div>
                <span>แก้ไข</span>
              </v-btn>

              <v-btn
                text
                class="d-flex align-center action-btn ml-2"
                @click="$emit('delete', item)"
              >
                <div class="detail-btn mr-2">
                  <v-icon size="20" color="#EE2526">
                    mdi-trash-can-outline
                  </v-icon>
                </div>
                <span>ลบ</span>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <v-row class="mt-4" v-if="localBoards.length > 10">
        <v-col
          cols="12"
          md="6"
          class="d-flex align-center justify-center justify-md-start"
        >
          <span class="count-text mr-2">แสดง</span>

          <v-menu v-model="menu" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="custom-select"
                v-bind="attrs"
                v-on="on"
                :class="{ 'menu-open': menu }"
              >
                <span class="items-per-page-text">
                  {{ currentItemsPerPageText }}
                </span>
                <img src="@/assets/caret_down.png" class="caret-icon ml-1" />
              </div>
            </template>

            <v-list>
              <v-list-item
                v-for="option in itemsPerPageOptions"
                :key="option.value"
                @click="selectOption(option)"
              >
                <v-list-item-title>{{ option.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <span class="count-text ml-2">
            จากทั้งหมด {{ localBoards.length }} รายการ
          </span>
        </v-col>

        <v-col
          cols="12"
          md="6"
          class="d-flex align-center justify-center justify-md-end pa-0"
        >
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            prev-icon="mdi-chevron-left"
            next-icon="mdi-chevron-right"
            class="mx-2"
            color="#F4811F"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Table",

  props: {
    boards: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      page: 1,
      menu: false,
      itemsPerPage: 10,
      itemsPerPageOptions: [
        { text: "10", value: 10 },
        { text: "100", value: 100 },
        { text: "ทั้งหมด", value: -1 },
      ],
    };
  },

  computed: {
    localBoards() {
      return Array.isArray(this.boards) ? this.boards : [];
    },
    pageCount() {
      if (this.itemsPerPage === -1) return 1;
      return Math.ceil(this.localBoards.length / this.itemsPerPage);
    },

    pagedItems() {
      if (this.itemsPerPage === -1) return this.localBoards;
      const start = (this.page - 1) * this.itemsPerPage;
      return this.localBoards.slice(start, start + this.itemsPerPage);
    },

    tableHeight() {
      return "600px";
    },

    currentItemsPerPageText() {
      const opt = this.itemsPerPageOptions.find(
        (x) => x.value === this.itemsPerPage
      );
      return opt ? opt.text : this.itemsPerPage;
    },

    // Fixed width for actions column
    actionsColWidth() {
      return 180;
    },
    
    tableVars() {
      return {
        "--actions-col": `${this.actionsColWidth}px`,
      };
    },

    headers() {
      return [
        {
          text: "รูปภาพ",
          value: "image",
          align: "left",
          sortable: false,
          width: "100px",
          class: "header-text",
        },
        {
          text: "หัวข้อข่าว",
          value: "title",
          align: "left",
          sortable: true,
           class: "header-text",
        },
        {
          text: "สถานะ",
          value: "status",
          align: "left",
          sortable: true,
          width: "120px",
           class: "header-text",
        },
         {
          text: "ผู้เขียน",
          value: "author",
          align: "left",
          sortable: true,
          width: "150px",
           class: "header-text",
        },
        {
          text: "Tags",
          value: "tags",
          align: "left",
          sortable: false,
           class: "header-text",
        },
        {
          text: "วันที่สร้าง",
          value: "createdAt",
          align: "left",
          sortable: true,
          width: "180px",
           class: "header-text",
        },
        {
          text: "จัดการ",
          value: "actions",
          align: "center",
          sortable: false,
          width: `${this.actionsColWidth}px`,
          class: "header-actions",
          cellClass: "cell-actions",
        },
      ];
    },
  },

  watch: {
    page() {
      this.scrollToTopOfTable();
    },
    boards() {
      this.page = 1;
      this.scrollToTopOfTable();
    },
  },

  methods: {
    formatDate(d) {
      if (!d) return "-";
      const date = new Date(d);
      if (isNaN(date.getTime())) return "-";

      const monthsFullThai = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      const day = date.getDate();
      const month = monthsFullThai[date.getMonth()];
      const year = date.getFullYear() + 543;
      return `${day} ${month} ${year}`;
    },

    getStatusColor(status) {
      if (status === "เผยแพร่") return "green";
      if (status === "ซ่อน") return "grey";
      return "blue";
    },

    selectOption(option) {
      this.itemsPerPage = option.value;
      this.page = 1;
      this.menu = false;
    },

    scrollToTopOfTable() {
      this.$nextTick(() => {
        const wrapper = this.$el.querySelector(".v-data-table__wrapper");
        if (wrapper) {
          wrapper.scrollTo({ top: 0 });
        } else {
          window.scrollTo({ top: 0 });
        }
      });
    },

    getImage(imagePath) {
      if (!imagePath) return require("@/assets/no-image.jpg");
      if (imagePath.startsWith("http")) return imagePath;
      return `${process.env.VUE_APP_API_URL}${imagePath}`;
    },
  },
};
</script>

<style scoped>
.card-container {
  overflow: hidden !important;
  border-radius: 12px !important;
  box-shadow: 0px 0px 2px 0px #1018280f, 0px 0px 3px 0px #1018281a !important;
}

::v-deep(.header-text),
::v-deep(.header-actions) {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #6b717f !important;
  background-color: #f9fafc !important;
  box-shadow: none !important;
}

::v-deep(.cell-actions) {
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 1;
}
::v-deep(.header-actions) {
  position: sticky;
  right: 0;
  background: #f9fafc;
  box-shadow: -2px 0 3px -1px #1018280f !important;
}

.action-btn {
  min-width: 0 !important;
  padding: 0 4px !important;
}
.detail-btn {
  border-radius: 4px !important;
  padding: 2px !important;
  box-shadow: 0px 0px 2px 0px #1018280f, 0px 0px 3px 0px #1018281a !important;
  width: 24px !important;
  height: 24px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.count-text,
.items-per-page-text {
  font-size: 14px;
  font-weight: 400;
  color: #394253;
}

.custom-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px 8px;
  cursor: pointer;
}
.caret-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s;
}
.custom-select.menu-open .caret-icon {
  transform: rotate(180deg);
}

::v-deep .v-pagination__item,
::v-deep .v-pagination__navigation {
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 8px !important;
  width: 34px !important;
  height: 34px !important;
  box-shadow: 0px 0px 2px 0px #1018280f, 0px 0px 3px 0px #1018281a !important;
}
</style>
